import(/* webpackMode: "eager" */ "/workspace/client/src/app/main-site/demo/client_page.tsx")